import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { AuthWrapper, AuthContainer, LangDropdown } from 'components/ui/index';
import classNames from 'classnames/bind';
import queryString from 'query-string';
import ResetPasswordForm from '../components/ResetPasswordForm';
import styles from '../index.less';

const cx = classNames.bind(styles);

const ResetPassword = ({
  location
}) => {
  const actions = (
    <div className={cx('resetPassword-actions-container')}>
      <div>
        <FormattedMessage id="page.Auth.backToLogin" />
        <Link to="/auth/login">
          <FormattedMessage id="page.Auth.login">
            {text => <span style={{ color: '#677dbd' }}>{text}</span>}
          </FormattedMessage>
        </Link>
      </div>
      <LangDropdown />
    </div>
  );

  const { search } = location;
  const { email, token } = queryString.parse(search);

  return (
    <AuthWrapper>
      <AuthContainer
        containerClass={cx('resetPassword-container')}
        title={<FormattedMessage id="page.Auth.resetPassword" />}
        actions={actions}
      >
        <div className={cx('resetPassword-content')}>
          {email &&
            <div className={cx('resetPassword-content-text')}>
              <FormattedMessage id="page.Auth.requestedToReset" tagName="p" />
              <p className={cx('resetPassword-content-email')}>{email}</p>
            </div>
          }
          <ResetPasswordForm
            email={email}
            token={token}
          />
        </div>
      </AuthContainer>
    </AuthWrapper>
  );
};

export default withRouter(ResetPassword);



// WEBPACK FOOTER //
// ./src/views/Auth/ResetPassword/container/index.jsx